import { render, staticRenderFns } from "./payuView.vue?vue&type=template&id=913c25b4&"
import script from "./payuView.vue?vue&type=script&lang=js&"
export * from "./payuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "payuView.vue"
export default component.exports